export default __webpack_public_path__ + "static/media/html5.373b575a.png";